(function () {
  var refreshToken = 0;
  var drawerObserver = null;

  function getDrawer() {
    return document.querySelector('.js-cart-drawer');
  }

  function shouldUseDrawer() {
    return !!(window.theme && theme.settings && theme.settings.afterAddToCart === 'drawer');
  }

  function releasePersistentOpen(drawer) {
    if (!drawer) return;
    if (typeof drawer.releasePersistentOpen === 'function') {
      drawer.releasePersistentOpen();
    } else {
      delete drawer.dataset.sjPersistOpen;
    }
  }

  function holdDrawerOpen(drawer) {
    if (!drawer || !shouldUseDrawer()) return;
    if (typeof drawer.persistOpenAfterAdd === 'function') {
      drawer.persistOpenAfterAdd();
    } else {
      drawer.dataset.sjPersistOpen = 'true';
    }
  }

  function openDrawer(drawer, opener) {
    if (!drawer || typeof drawer.open !== 'function' || !shouldUseDrawer()) return;
    if (!drawer.hasAttribute('open')) {
      drawer.open(opener || null);
    }
  }

  /**
   * Replace the EXISTING cart-form contents with a freshly-rendered Shopify
   * cart-drawer section. Keeping the current cart-drawer/cart-form nodes avoids
   * breaking custom-element event handlers, while the inner markup is guaranteed
   * to represent the cart AFTER the successful add.
   */
  function applyFreshDrawerHtml(drawer, html) {
    var holder = document.createElement('div');
    holder.innerHTML = html;

    var freshDrawer = holder.querySelector('.js-cart-drawer') || holder.querySelector('cart-drawer');
    var freshForm = freshDrawer ? freshDrawer.querySelector('cart-form') : holder.querySelector('cart-form');
    var currentForm = drawer.querySelector('cart-form');

    if (!freshForm || !currentForm) return false;

    currentForm.innerHTML = freshForm.innerHTML;
    currentForm.className = freshForm.className;

    // Synchronise cart-form attributes without replacing the custom element itself.
    Array.from(currentForm.attributes).forEach(function (attr) {
      if (!freshForm.hasAttribute(attr.name)) currentForm.removeAttribute(attr.name);
    });
    Array.from(freshForm.attributes).forEach(function (attr) {
      currentForm.setAttribute(attr.name, attr.value);
    });

    currentForm.classList.remove('cart-form--refreshing');
    currentForm.dispatchEvent(new CustomEvent('on:cart:after-merge', {
      bubbles: true,
      cancelable: false
    }));
    return true;
  }

  /**
   * After Add to Cart succeeds, get a brand-new drawer section from Shopify and
   * ONLY THEN open it. This removes the race where the old empty drawer opens,
   * flashes "Your bag is empty", and closes before the added product is rendered.
   */
  async function refreshThenOpen(opener) {
    var drawer = getDrawer();
    if (!drawer || !shouldUseDrawer()) return;

    var myToken = ++refreshToken;
    holdDrawerOpen(drawer);

    var sectionId = drawer.dataset.sectionId;
    if (!sectionId) {
      openDrawer(drawer, opener);
      return;
    }

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var separator = root.indexOf('?') === -1 ? '?' : '&';
      var response = await fetch(root + separator + 'section_id=' + encodeURIComponent(sectionId) + '&_sj=' + Date.now(), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Cart drawer refresh failed: ' + response.status);
      var html = await response.text();
      if (myToken !== refreshToken) return;

      applyFreshDrawerHtml(drawer, html);
    } catch (error) {
      // Do not send the shopper away or close the drawer. The add itself already
      // succeeded; open the current drawer as a safe fallback.
      console.warn(error);
    }

    if (myToken !== refreshToken) return;

    // Open after DOM has painted the confirmed cart contents.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (myToken !== refreshToken) return;
        holdDrawerOpen(drawer);
        openDrawer(drawer, opener);
      });
    });
  }

  function watchDrawer(drawer) {
    if (!drawer || drawerObserver) return;

    // If another app/theme script removes `open` after a successful add, restore
    // it. Explicit shopper closes release the lock first in CartDrawer.handleClick
    // / Escape handling, so normal close behaviour remains available.
    drawerObserver = new MutationObserver(function (mutations) {
      if (!shouldUseDrawer() || drawer.dataset.sjPersistOpen !== 'true') return;
      var changed = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'open';
      });
      if (changed && !drawer.hasAttribute('open')) {
        window.requestAnimationFrame(function () {
          if (drawer.dataset.sjPersistOpen === 'true' && !drawer.hasAttribute('open')) {
            openDrawer(drawer, null);
          }
        });
      }
    });

    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  function initCartEnhancements(root) {
    if (!root) return;
    watchDrawer(root);

    if (root.dataset.sjEnhanced === 'true') return;
    root.dataset.sjEnhanced = 'true';

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('.sj-cart-toggle');
      if (!toggle || !root.contains(toggle)) return;
      var pressed = toggle.getAttribute('aria-pressed') === 'true';
      toggle.setAttribute('aria-pressed', String(!pressed));
      toggle.classList.toggle('is-off', pressed);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-cart-drawer').forEach(initCartEnhancements);
  });

  document.addEventListener('on:cart:add', function (event) {
    var opener = event.target && event.target.querySelector
      ? event.target.querySelector('[name="add"]')
      : null;
    refreshThenOpen(opener);
  });

  document.addEventListener('on:cart:after-merge', function () {
    var drawer = getDrawer();
    if (drawer) initCartEnhancements(drawer);
  });

  // Do not allow unrelated programmatic close events to undo the post-add drawer.
  document.addEventListener('dispatch:cart-drawer:close', function (event) {
    var drawer = getDrawer();
    if (drawer && drawer.dataset.sjPersistOpen === 'true') {
      event.stopImmediatePropagation();
    }
  }, true);

  // Explicit overlay click is a shopper close, so release persistence first.
  document.addEventListener('click', function (event) {
    var drawer = getDrawer();
    if (!drawer || drawer.dataset.sjPersistOpen !== 'true') return;
    if (event.target && event.target.matches && event.target.matches('.js-overlay')) {
      releasePersistentOpen(drawer);
    }
  }, true);
})();
